
// 所有页面路由统一管理
const iot = [
  {
    path: '/',
    name: 'home',
    component: resolve => require(['@/components/homeHeader'], resolve),
    redirect: '/home', // 路由重定向
    children: [
      // 首页
      { path: '/home', component: resolve => require(['@/views/Home'], resolve) },
      // 个人中心
      { path: '/user', component: resolve => require(['@/views/user'], resolve) },
      // 购物车
      { path: '/shopcar', component: resolve => require(['@/views/shopcar'], resolve) },
      // 填写订单信息
      { path: '/step', component: resolve => require(['@/views/step'], resolve) },
      // 支付成功
      { path: '/payok', component: resolve => require(['@/views/payok'], resolve) },
      // 关于奉航
      { path: '/aboutus', component: resolve => require(['@/views/aboutus'], resolve) },
      // 新闻中心
      { path: '/news', component: resolve => require(['@/views/news'], resolve) },
      // 新闻中心详情
      { path: '/newsDetail', component: resolve => require(['@/views/newsDetail'], resolve) },
      // 产品展示
      { path: '/product', component: resolve => require(['@/views/product'], resolve) },
      // 产品展示详情
      { path: '/productDetail', component: resolve => require(['@/views/productDetail'], resolve) },
      // 技术研发
      { path: '/technology', component: resolve => require(['@/views/technology'], resolve) },
      // 客户服务
      { path: '/customer', component: resolve => require(['@/views/customer'], resolve) },
      // 企业文化
      { path: '/culture', component: resolve => require(['@/views/culture'], resolve) },
      // 党群工作
      { path: '/working', component: resolve => require(['@/views/working'], resolve) },
      // 党群工作详情
      { path: '/workingDetail', component: resolve => require(['@/views/workingDetail'], resolve) },
      // 搜索结果
      { path: '/search', component: resolve => require(['@/views/search'], resolve) },
      // 空白页
      { path: '/back', component: resolve => require(['@/views/back'], resolve) },
    ]
  },
]

export default iot